module.exports = __webpack_public_path__ + "static/media/WEBSITE_MELISSA.ccdf97b8.jpg";